import React, { useEffect, useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css'; 
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllClientsAction } from 'actions/client';
import { useDebounce } from 'helper/utils';

const AutocompliteClient = ({selectedOption, setSelectedOption}) => {
	const dispatch = useDispatch();
	const {clients} = useSelector(state => state.clients);
  const [searchText, setSearchText] = useState('');
  const search=useDebounce(searchText,500)
  const handleInputChange = (text) => {
    setSearchText(text);
  };
  const page=1;
	useEffect(() => {
		dispatch(fetchAllClientsAction(search,page))
		 
	  }, [dispatch,search,page]);

  const handleSelection = (selected) => {

    
    if(selected.length>0){
        setSelectedOption(selected[0]._id);
        
    }
   
  };
 
  const options = [
    
    ...clients.map(item => item),
    
  ];

  return (
    <div className="mb-3">
      <Typeahead
        id="autocomplete-example"
        labelKey="name" 
        options={options}
        placeholder="Type to search..."
        onChange={handleSelection}
        onInputChange={(text) => handleInputChange(text)}
      />
    </div>
  );
};

export default AutocompliteClient;
